import React from 'react';
import { useInView } from 'react-intersection-observer';

interface LazyLoadProps {
  children: React.ReactNode;
  threshold?: number;
  rootMargin?: string;
  fallback?: React.ReactNode;
}

/**
 * Lazy load wrapper component - renders children only when visible in viewport
 * Uses Intersection Observer API for efficient viewport detection
 */
export const LazyLoad: React.FC<LazyLoadProps> = ({
  children,
  threshold = 0.1,
  rootMargin = '200px',
  fallback = <div className="lazy-placeholder">Loading...</div>
}) => {
  const { ref, inView } = useInView({
    threshold,
    rootMargin,
    triggerOnce: true, // Only trigger once (don't unload when scrolling away)
  });

  return <div ref={ref}>{inView ? children : fallback}</div>;
};

export default LazyLoad;
